<template>
  <section v-if="activity" class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">Member activity</h3>
    </div>
    <p class="text-sm text-gray-500 mt-0 mb-3">What members do on the platform, and when they are most active.</p>

    <div class="grid gap-6 lg:grid-cols-2">
      <!-- Activity breakdown -->
      <div>
        <h4 class="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">Actions by type</h4>
        <div v-if="breakdown.length" class="space-y-2.5">
          <div v-for="item in breakdown" :key="item.label">
            <div class="tw-flex items-center justify-between text-sm mb-1">
              <span class="text-gray-600 truncate">{{ item.label }}</span>
              <span class="text-gray-400">{{ item.count }}</span>
            </div>
            <div class="h-2 rounded-full bg-gray-100 overflow-hidden">
              <div class="h-full rounded-full bg-primary" :style="{ width: barWidth(item.count) + '%' }"></div>
            </div>
          </div>
        </div>
        <div v-else class="text-sm text-gray-400 py-2">No activity this month</div>
      </div>

      <!-- Heatmap -->
      <div>
        <h4 class="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">Active times (weekday × hour)</h4>
        <div v-if="heatmapMax > 0" class="overflow-x-auto">
          <div class="inline-block">
            <div v-for="(row, dayIndex) in heatmap" :key="dayIndex" class="tw-flex items-center gap-1 mb-1">
              <span class="text-[10px] text-gray-400 w-8 shrink-0">{{ dayLabels[dayIndex] }}</span>
              <span
                v-for="(count, hour) in row"
                :key="hour"
                class="rounded-sm"
                style="width: 11px; height: 11px;"
                :style="{ backgroundColor: cellColor(count) }"
                v-tooltip.top="dayLabels[dayIndex] + ' ' + hour + ':00 — ' + count + ' actions'"
              ></span>
            </div>
            <div class="tw-flex items-center gap-1 mt-1 pl-9 text-[10px] text-gray-400">
              <span style="width: 11px;">0</span>
              <span class="ml-auto">6</span>
              <span class="ml-auto">12</span>
              <span class="ml-auto">18</span>
              <span class="ml-auto">23</span>
            </div>
          </div>
        </div>
        <div v-else class="text-sm text-gray-400 py-2">No activity this month</div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'HeartbeatActivityBreakdown',
    props: {
      activity: Object,
    },
    computed: {
      breakdown () {
        return (this.activity && this.activity.activity_breakdown) || []
      },
      breakdownMax () {
        return this.breakdown.reduce((max, item) => Math.max(max, item.count), 0)
      },
      heatmap () {
        return (this.activity && this.activity.heatmap) || []
      },
      heatmapMax () {
        return (this.activity && this.activity.heatmap_max) || 0
      },
      dayLabels () {
        return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      },
    },
    methods: {
      barWidth (count) {
        if (!this.breakdownMax) {
          return 0
        }

        return Math.max(3, Math.round((count / this.breakdownMax) * 100))
      },
      cellColor (count) {
        if (!count || !this.heatmapMax) {
          return '#f3f4f6'
        }

        // Scale opacity between 0.15 and 1 so light cells stay visible
        const alpha = 0.15 + 0.85 * (count / this.heatmapMax)
        return `rgba(46, 89, 250, ${alpha.toFixed(2)})`
      },
    },
  }
</script>
